import { render } from "./prenotazioniGestione.vue?vue&type=template&id=494d4242&ts=true"
import script from "./prenotazioniGestione.vue?vue&type=script&lang=ts"
export * from "./prenotazioniGestione.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__